import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-protesto-estadual',
  templateUrl: './protesto-estadual.component.html',
  styleUrls: ['./protesto-estadual.component.scss']
})
export class ProtestoEstadualComponent implements OnInit {

  @Input() consulta: any;
  @Input() titulo="";
  @Input() idConsulta="";
  @Input() tipoConsulta="";
  @Input() codigoControle="";
  @Output() update = new EventEmitter();

  statusMsg = null;
  status = "info";
  msgNull = 'NÃO INFORMADO';

  constructor() { }

  ngOnInit() {
    this.getStatus();
  }

  getStatus() {
    if(!this.consulta.registros || this.consulta.registros.length == 0) {
      this.codigoControle = 'SEMREGISTRO_OK';
    }
    this.codigoControle === 'SEMREGISTRO_OK' ? this.status = 'success' : 'warning';
    this.codigoControle === 'OK' ? this.status = 'warning' : 'success';
  }

}
